import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Promotion, BannerLocation, PromotionAnalytics, SelectListItem } from './../models/marketing.model';
import { AuthService } from "./auth.service";
import { AccessMenuViewModel } from '../models/AccessMenuViewModel';

@Injectable()
export class MarketingService {
    base_url: string = "api/Marketing";
    private watchSearchSubject = new BehaviorSubject<string>("");
    currentWatch = this.watchSearchSubject.asObservable();
    constructor(private http: HttpClient,
        private authService: AuthService
        ) { }

    monitorSearchKeyWordChange(searchKeyWord: string): void {
        this.watchSearchSubject.next(searchKeyWord);
    }

    getPromotion(id: number): Observable<Promotion> {
        return this.http.get<Promotion>(this.base_url + '/GetPromotion?id=' + id)
            .pipe(catchError(this.authService.handleError));
    }

    getPromotionList(type: string, locationId?: number, bannerQuantity?: number): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/GetPromotionList?type=' + type + '&locationId=' + locationId  + '&bannerQuantity=' + bannerQuantity)
            .pipe(catchError(this.authService.handleError));
    }

    getEmergencyBannerList(type: string, expiryDate: string): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/GetPromotionList?type=' + type + '&expiryDate=' + expiryDate)
            .pipe(catchError(this.authService.handleError));
    }

    getPromotionListByDate(type: string, startDate: string, endDate: string , locationId?: Array<BannerLocation>): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/GetPromotionListByDate?locationId=' + locationId  + '&startDate=' + startDate  + '&endDate=' + endDate)
            .pipe(catchError(this.authService.handleError));
    }

    updateFeaturedSpot(id: number, isFeatured: boolean): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/UpdateFeaturedSpot?id=' + id + '&isFeatured=' + isFeatured)
            .pipe(catchError(this.authService.handleError));
    }

    savePromotion(promotion:Promotion): Observable<any> {
        return this.http.post(this.base_url + '/SavePromotion', promotion)
            .pipe(catchError(this.authService.handleError));
    }

    deletePromotion(promotionId:number): Observable<boolean> {
        return this.http.get<boolean>(this.base_url + '/DeletePromotion?id=' + promotionId)
            .pipe(catchError(this.authService.handleError));
    }

    getBannerLocation(): Observable<BannerLocation[]> {
        return this.http.get<BannerLocation[]>(this.base_url + '/bannerLocations')
            .pipe(catchError(this.authService.handleError));
    }

    UpdatePromotionAnalytics(bannerId: number, analyticsType: string): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/UpdatePromotionAnalytics?bannerId=' + bannerId  + '&analyticsType=' + analyticsType)
            .pipe(catchError(this.authService.handleError));
    }

    UpdatePromotionListAnalytics(bannerIds: any, analyticsType: string): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/UpdatePromotionListAnalytics?bannerIds=' + bannerIds  + '&analyticsType=' + analyticsType)
            .pipe(catchError(this.authService.handleError));
    }

    getPromotionListWithAnalytics(type: string, locationId: number): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/GetPromotionListWithAnalytics?type=' + type + '&locationId=' + locationId)
            .pipe(catchError(this.authService.handleError));
    }

    getPromotionAnalytics(bannerIds: Array<number>): Observable<Promotion[]> {
        // return this.http.get(this.base_url + '/getPromotionAnalytics?bannerIds=' + bannerIds)
        //     .pipe(catchError(this.authService.handleError));
           return this.http.post<Promotion[]>(this.base_url + '/getPromotionAnalytics', bannerIds)
            .pipe(catchError(this.authService.handleError));
    }

    getPromotionAnalyticsReport(bannerId: number): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/GetAnalyticsReport?bannerId=' + bannerId )
            .pipe(catchError(this.authService.handleError));
    }

    UpdateAnalytics( analyticsTypeId: number, analyticsId: string, impressionType: string): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(this.base_url + '/UpdateAnalytics?analyticsTypeId=' + analyticsTypeId  + '&analyticsId=' + analyticsId + '&impressionType='+impressionType)
            .pipe(catchError(this.authService.handleError));
    }
    
    getHtmlContent(url: string) {
        const headers = new HttpHeaders({
            'Content-Type' : ' text/plain'
        })
        return this.http.get(url, {responseType:'text'})
        .pipe(catchError(this.authService.handleError));
    }
    // private handleError(error: HttpErrorResponse) {
    //     console.log('server error:', error);

    //     if (error.error instanceof ErrorEvent) {
    //         let errMessage = '';
    //         try {
    //             errMessage = error.error.message;
    //         } catch (err) {
    //             errMessage = error.statusText;
    //         }
    //         return Observable.throw(errMessage);
    //     }
    //     return Observable.throw(error.error || 'ASP.NET Core server error');
    // }

    getProntoBrands() {
        return this.http.get<SelectListItem[]>(this.base_url + '/getProntoBrands')
            .pipe(catchError(this.authService.handleError));
    }

    getQuoteBrands() {
        return this.http.get<SelectListItem[]>(this.base_url + '/getQuoteBrands')
            .pipe(catchError(this.authService.handleError));
    }
}
